<script setup lang="ts">
import BaseForm from "~/components/ui/BaseForm.vue";
import FormCard from "~/components/ui/FormCard.vue";
import BackButton from "~/components/inputs/BackButton.vue";

const { locale } = await useLocale("ui", "custom_credit", true);
</script>

<template>
  <BaseForm>
    <template #upper>
      <FormCard :has-submit="false">
        <div
          class="container mx-auto py-20 text-sm sm:text-base leading-tight text-gray-700"
        >
          <p v-html="locale?.text"></p>
        </div>

        <template #link>
          <BackButton :event="`goBack`" @go-back="$emit('goBack')" />
        </template>
      </FormCard>
    </template>
  </BaseForm>
</template>

<style scoped></style>
